import { render } from "./ProductsFooter.vue?vue&type=template&id=1880033e&scoped=true"
import script from "./ProductsFooter.vue?vue&type=script&lang=js"
export * from "./ProductsFooter.vue?vue&type=script&lang=js"

import "./ProductsFooter.vue?vue&type=style&index=0&id=1880033e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1880033e"]])

export default __exports__